import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

// Component for Variables content
const GlobalVariables = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box style={{
            display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, overflowY: 'auto',
            p: 3
        }}>
            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <strong>Global Variables</strong>
                <br /><br />
                <p>
                    Global variables are user-defined key-value pairs scoped at the
                    <strong> workspace level</strong>. They are accessible throughout the workspace —
                    across <strong>all collections, requests, and flows</strong>. These variables provide
                    a convenient way to define values that need to be shared consistently across the entire project.
                </p>

                <p>
                    They are especially useful for defining values that are not tied to a specific environment
                    or collection — such as app-wide settings, common tokens, fallback URLs, or constants.
                </p>

                <p>
                    Like all variables in HawkClient, Global Variables can be referenced using double curly braces syntax:
                    <code>{` {{variableName}} `}</code>. This makes your request URLs, headers, and body payloads
                    more dynamic and maintainable.
                </p>

                <p>
                    <strong>Example use case:</strong> If your application communicates with multiple services,
                    and one of them has a static utility endpoint like
                    <code> https://utils.api.example.com</code>, you can define a global variable
                    <code>utilsBaseUrl</code> with that value. Then, in your requests, you can use:
                    <code>{` {{utilsBaseUrl}}/status `}</code>, making it easy to update in one place if it ever changes.
                </p>

                <p>
                    <strong>Storage:</strong> Global variables are stored inside your workspace folder, under the
                    <code> variables </code> directory, in a file named <code> globalVariable.json </code>.
                    This makes them easy to version control with Git and collaborate across teams.
                </p>
            </Typography>
            <img
                src="/docs/globalVariables.png"
                alt="validations"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    // maxWidth: '800px',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />

            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <p>
                    <strong>Variable Precedence</strong> is crucial when a variable key exists in multiple scopes.
                    HawkClient resolves variables using the following order of precedence:
                </p>
                <ol style={{ paddingLeft: '20px' }}>
                    <li><strong>Request Variables</strong> – highest priority</li>
                    <li><strong>Environment Variables</strong></li>
                    <li><strong>Collection Variables</strong></li>
                    <li><strong>Global Variables</strong> – lowest priority</li>
                </ol>
                <p>
                    This means that a variable defined at the request level will always override the same key
                    defined in global or other scopes.
                </p>
            </Typography>
        </Box>
    )
};

export default GlobalVariables;